import PageContent from "../../components/PageContent";
import PageTitle from "../../components/PageTitle";
import IndustryUpdateForm from "./components/IndustryUpdateForm";

const IndustryConfigurations = () => {
    return (
        <>
            <PageTitle title="Configurações da empresa"/>
            <PageContent>
                <IndustryUpdateForm />
            </PageContent>
        </>
    )
}

export default IndustryConfigurations;